import * as React from 'react';
import * as styles from './styles.css';

import { Container } from '../Container';
import { Tabs } from '../Tabs';
import { TabContent } from './TabContent';
import { TIndexTab, ILegend } from '../../types/redux';

import { trackTabClick } from './tracking';

export interface IGraphsProps {
  legend: ILegend[];
  graph: React.ReactNode;
  toggleGraphRegion(region: number): void;
  getGraphs(indexTab: TIndexTab): void;
}

const tabs = [
  'Число сделок с физическими лицами на первичном рынке',
  'Доля ипотечных сделок на первичном рынке',
  'Средняя цена квадратного метра на вторичном рынке',
];

export function Graphs({ legend, graph, toggleGraphRegion, getGraphs }: IGraphsProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        <Container>
          <div className={styles['tabs']}>
            <Tabs
              onChangeTab={(indexTab: TIndexTab) => {
                getGraphs(indexTab);
                trackTabClick(indexTab);
              }}
              tabList={tabs.map(tab => {
                return {
                  label: tab,
                  content: (
                    <TabContent title={tab} legend={legend} graph={graph} toggleGraphRegion={toggleGraphRegion} />
                  ),
                };
              })}
            />
          </div>
        </Container>
      </div>
    </div>
  );
}
